import { WarningBox } from "pages/Sikring/components/InfoBox";
import { firstDayOfMonth, fmtDate, isBackInTime } from "pages/Sikring/sikringUtils";

/** Varsel når sikringen starter før dagens dato. Vises ikke for en periode som starter i dag eller senere. */
export function BackInTimeWarning({ startMonth }: Readonly<{ startMonth: string }>) {
	if (!isBackInTime(startMonth)) return null;
	return <WarningBox tone="orange" heading="Du oppretter sikring tilbake i tid." body={`Sikringen starter ${fmtDate(firstDayOfMonth(startMonth))}.`} />;
}
